const bannerSlider = new Swiper('.banner_slider__slider', {
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});

//  tabs
(function() {
    const tabs = document.querySelectorAll('.tabs__item')
    const tabContent = document.querySelectorAll('.tabs__content')
    const showMoreButton = document.querySelectorAll('.btn--show_more')

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(el => {
                el.classList.remove('selected')
            })
            tab.classList.add('selected')
            const value = tab.dataset.block

            tabContent.forEach(item => {
                item.classList.remove('selected')
            });

            tabContent.forEach(item => {
                if (item.dataset.block == value) {
                    item.classList.add('selected')
                }
            });
        })
    });

    showMoreButton.forEach(button => {
        button.addEventListener('click', () => {
            button.parentElement.querySelectorAll('.collections_tabs__content .card-wrapper.hidden').forEach(el => {
                el.classList.remove('hidden')
            })

            button.classList.add('hidden')
        })
    });
})();

// collection tabs

// faq
(function() {
    const container = document.querySelectorAll('.faq__title_container')
    
    container.forEach(element => {
        element.addEventListener('click', () => {
            console.log(element)
            console.log(element.nextElementSibling)
            element.parentElement.classList.toggle('active')
            element.nextElementSibling.classList.toggle('active')
        })
    });
})();
// faq

// show header search
(function () {
    const buttonSearch = document.querySelector('.header__icon--search')
    const nav = document.querySelector('.header__inline-menu')
    const closeSearch = document.querySelector('.hideSearch')
    
    buttonSearch.addEventListener('click', () => {
        buttonSearch.classList.toggle('hidden')
        nav.classList.toggle('header__inline-menu--show_search')

    })
    closeSearch.addEventListener('click', () => {
        buttonSearch.classList.toggle('hidden')
        nav.classList.toggle('header__inline-menu--show_search')

    })
})();
// show header search

(function () {
    const closeMenuDrawerButton = document.querySelector('.menu-drawer__close')

    closeMenuDrawerButton.addEventListener('click', () => {
        document.querySelector('.Details-menu-drawer-container').click()
    })
})();
// reviews counter

(function () {
    if (document.body.classList.contains('template_product')) {
        window.addEventListener('load', () => {
            const target = document.querySelector('.reviews_counter')
            const value = document.querySelector('.jdgm-rev-widg').dataset.numberOfReviews

            target.innerHTML = value
        })
    }
})();

// // wishlist counter

// function renderWishlistCounter(swat) {
// 	var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Custom header can be added here.*/
// 	if (counter_elem) {
// 		for (var i = 0; i < counter_elem.length; i++) {
// 			if (swat.renderWishlistCount) {
// 				swat.renderWishlistCount(counter_elem[i], function(count, element) {
// 					console.log("debug - renderWishlistCount", count, element); 
// 				});
// 			}
// 		}
// 	}
// }
// if (!window.SwymCallbacks) {
// 	window.SwymCallbacks = [];
// }
// window.SwymCallbacks.push(renderWishlistCounter); 